import styles from "../landing-page-mobile-one.module.css";
import { CTAButton } from "BEDROCK/shared-components/cta-button";
import { useAnalyticsTracker } from "analytics-tracker";

interface ProductSectionMobileProps {
  onClick: () => void;
}

export const ProductSectionMobile = (props: ProductSectionMobileProps) => {
  const { trackEvent } = useAnalyticsTracker();

  const handleImageClick = () => {
    trackEvent("Mobile landing CTA clicked", { section: "product", button: "product_image" });
    props.onClick();
  };

  const handleCTAClick = () => {
    trackEvent("Mobile landing CTA clicked", { section: "product", button: "create_your_print" });
    props.onClick();
  };

  return (
    <section className={styles.productSection}>
      <h2 className={styles.productTitle}>YOUR ADVENTURE, ON YOUR WALL</h2>
      <p className={styles.productSubtitle}>
        Printed in vibrant colours on a premium, robust, aluminium dibond
        material suitable for hanging absolutely anywhere
      </p>
      <button className={styles.productImageButton} onClick={handleImageClick}>
        <img
          src="/landing-page/landing-mobile-one/Section3/image1.png"
          alt="Premium aluminium dibond print"
          className={styles.productImage}
        />
      </button>
      <CTAButton
        variant="SECONDARY"
        title="CREATE YOUR PRINT"
        onClick={handleCTAClick}
        className={styles.sectionCTA}
      />
    </section>
  );
};
